<template>
  <nav class="gfr-menu">
    <slot />
  </nav>
</template>
<script setup lang="ts"></script>
<style lang="scss">
@import './styles/globe.scss';
</style>
